import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { initLenis, scrollTop } from "./lib/lenis";
import Home from "./pages/Home";
import Properties from "./pages/Properties";
import PropertyDetail from "./pages/PropertyDetail";
import Tools from "./pages/Tools";
import Insights from "./pages/Insights";
import InsightDetail from "./pages/InsightDetail";
import { AdminProvider } from "./admin/AdminContext";
import { Protected } from "./admin/Protected";
import { AdminLayout } from "./admin/AdminLayout";
import AdminLogin from "./admin/Login";
import AdminDashboard from "./admin/Dashboard";
import AdminListings from "./admin/Listings";
import AdminEditor from "./admin/Editor";
import AdminEnquiries from "./admin/Enquiries";
import AdminImport from "./admin/Import";
import AdminTeam from "./admin/Team";
import AdminGuide from "./admin/Guide";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    scrollTop();
  }, [pathname]);
  return null;
};

const AdminPage = ({ children, role }) => (
  <Protected role={role}>
    <AdminLayout>{children}</AdminLayout>
  </Protected>
);

function Shell() {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) {
    return (
      <AdminProvider>
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminPage><AdminDashboard /></AdminPage>} />
          <Route path="/admin/listings" element={<AdminPage><AdminListings /></AdminPage>} />
          <Route path="/admin/listings/new" element={<AdminPage><AdminEditor /></AdminPage>} />
          <Route path="/admin/listings/:id/edit" element={<AdminPage><AdminEditor /></AdminPage>} />
          <Route path="/admin/enquiries" element={<AdminPage><AdminEnquiries /></AdminPage>} />
          <Route path="/admin/import" element={<AdminPage><AdminImport /></AdminPage>} />
          <Route path="/admin/team" element={<AdminPage role="owner"><AdminTeam /></AdminPage>} />
          <Route path="/admin/guide" element={<AdminPage><AdminGuide /></AdminPage>} />
          <Route path="*" element={<AdminPage><AdminDashboard /></AdminPage>} />
        </Routes>
      </AdminProvider>
    );
  }
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/properties" element={<Properties />} />
        <Route path="/properties/:id" element={<PropertyDetail />} />
        <Route path="/tools" element={<Tools />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/insights/:slug" element={<InsightDetail />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div className="App min-h-screen bg-charcoal">
      <BrowserRouter>
        <ScrollManager />
        <Shell />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
